// extracted by mini-css-extract-plugin
export default {"logo-image":"SideBarComponent_logo-image_qqapS","dashboard-text":"SideBarComponent_dashboard-text_P51DZ","brand-image":"SideBarComponent_brand-image_ChMNc"};